import { createSlice } from "@reduxjs/toolkit";

const subscriptionsSlice = createSlice({
  name: "subscriptions",
  initialState: {
    data: [],
    totalRecords: 0,
    isLoading: false,
    error: null,
  },
  reducers: {
    setSubscriptions(state, action) {
      state.data = action.payload.data || [];
      state.totalRecords = action.payload.total || 0;
      state.isLoading = false;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setSubscriptions, setLoading, setError } = subscriptionsSlice.actions;
export default subscriptionsSlice.reducer;
